import React from "react";

export default () => {
  return (
    <div className="content">
      Data sourced from:{" "}
      <a
        href="https://docs.google.com/spreadsheets/d/1t0Mg_MIJG4KWljbnpn_7UC-k27NnXeiB_5YFSoACkik/"
        target="_blank"
        rel="noopener noreferrer"
      >
        MSM Infosheets
      </a>
    </div>
  );
};
